<!-- components/EditForm.vue -->
<template>
    <div class="edit-form">
        <el-form label-width="80px">
            <span v-html="introduceTextValue"></span>
            <div class="button-div">
                <el-button v-show="isShowButton_doNotShowAgain" type="primary" @click="doNotShowAgain">本次登录不再提示</el-button>
                <el-button @click="close">关闭</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>

export default {
    name: 'IntroducePage',
    props: {
        introduceTextValue: {
            type: String,
            default: () => "这是一段介绍"  // 展示介绍文本
        },
        isShowButton_doNotShowAgain: {
            type: Boolean,
            default: false  // 展示介绍文本
        }

    },
    data() {
        return {
            
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        doNotShowAgain() {
            this.$emit('doNotShowAgain');
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.edit-form {
    display: block;
    margin-bottom: 10px;
    padding: 6px;
}

.button-div {
    margin-left: 80px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 18px;
}
</style>